import { NextPage } from "next";
import MarketsOverview from "@/components/markets-pulse/MarketsPulse";
import useAppSubscriberUpgrade from "src/hooks/useAppSubscriberUpgrade";
import { useRecoilValue } from "recoil";
import { regionState, themeState, userDataState } from "@/lib/store";
import { useRouter } from "next/router";
import { useDebounce } from "react-use";
import PageSeo from "@/components/page-seo/PageSeo";

const HomePage: NextPage = (props) => {
    // After signup we land here with `?message=welcome` and need to pop
    // the payment modal. Previously this used `useOpenSubscriptionForm`
    // which always fires `restartSubscription()` with no code — but for
    // `app_subscriber_only` users `_app.tsx`'s `signedIn` handler had
    // already fired `restartSubscription("APPDISC")` a moment earlier,
    // resulting in two slow `/API/v2/user/new_subscription` calls
    // (one with APPDISC ~1s, one without ~3s) for the same modal open.
    //
    // Routing through `useAppSubscriberUpgrade` makes the right choice
    // automatically: APPDISC for app subscribers (dedup'd against the
    // earlier identical call by the in-flight Map in
    // controllers/subscription.ts), or the regular openSubscriptionForm
    // path for everyone else.
    const { handleAppSubscriberUpgrade } = useAppSubscriberUpgrade();

    const userData = useRecoilValue(userDataState);

    const { query } = useRouter();

    useDebounce(
        () => {
            if (query.message === "welcome" && userData?.first_name) {
                handleAppSubscriberUpgrade({ openPaymentModal: true });
            }
            if (query.hasOwnProperty("promo") && userData?.first_name) {
                query.promo ? sessionStorage.setItem("promoCode", query.promo as string) : sessionStorage.setItem("promoCode", "true");
            }
        },
        1000,
        [query.message, query.promo, userData?.first_name]
    );

    return (
        <>
            <PageSeo
                title="ORTEX: Global Financial Analytics"
                pageName="Global Financial Analytics"
                canonicalPath="/"
                description="ORTEX: Global Financial Analytics with live short interest, options, analyst data and much more"
                keywords="Stocks, Financial analytics, financial data, stock screening, short interest, short squeeze, options, options flow, gamma squeeze, fundamentals, stocks, NYSE, Nasdaq, equity, trading, trading ideas, trading signals, dividend"
            />
            <MarketsOverview />
        </>
    );
};

export default HomePage;
